





































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import LPFarmV2 from '@/components/LPFarmV2.vue';
import LPFarm from '@/components/LPFarm.vue';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import SquadSBC2 from '@/components/SquadBSC2.vue';
import AlpacaCard from '@/components/AlpacaCard.vue';
import ScarfFarm from '@/components/ScarfFarm.vue';
import SelectFarmerPopup from '@/components/SelectFarmerPopup.vue';
import { Alpaca } from '@/backend/type';
import { getAlpacaInfo } from '@/backend/requests';
import { ROUTE_ALPACA, ROUTE_FARM_TAB } from '@/router';
import { LPUserInfo, farmerTransfer, retrieve, validateAccount } from '@/utils/web3';

@Component({
  components: {
    SelectFarmerPopup,
    LPFarm,
    AlpacaBtn,
    AlpacaCard,
    SquadSBC2,
    ScarfFarm,
    LPFarmV2,
  },
})
export default class FarmBSC extends Vue {
  @Prop({
    required: false,
    default: 'swapV2New',
  })
  public tab!: 'swapV2New' | 'swapV2' | 'squad' | 'scarf' | 'swap';

  public curTab: 'swapV2New' | 'swapV2' | 'squad' | 'scarf' | 'swap' = 'swapV2New';

  get account() {
    return this.$store.getters.getAccount;
  }

  public mounted() {
    this.curTab = this.tab;
  }

  public async connectWallet() {
    await validateAccount(this);
  }

  public changeTab(tab: 'swap' | 'swapV2' | 'squad' | 'scarf' | 'swapV2New') {
    this.curTab = tab;
    this.$router.push({ name: ROUTE_FARM_TAB, params: {tab} });
  }
}
